import { useWatch } from 'react-hook-form';
import { Checkbox } from '@schibsted-svp/react-ui';
import { MediaLiveInputType } from 'services/admin-bff/contants';
import { useMediaLiveInputFormContext, useReservedMediaLiveInputs } from './hooks';
import { MediaLivePushInfo } from './MediaLivePushInfo';
import { MediaLiveInputsSelect } from './MediaLiveInputsSelect';
import { MediaLiveNetworkUrl } from './MediaLiveNetworkUrl';
import { MediaLiveSrtSettings } from './MediaLiveSrtSettings';

export function MediaLiveSource() {
    const allInputs = useReservedMediaLiveInputs();

    const { formApi } = useMediaLiveInputFormContext();
    const { control, register } = formApi;

    const inputType = useWatch({ name: 'inputType', control });
    const inputId = useWatch({ name: 'inputId', control });
    const pullSource = useWatch({ name: 'pull-source', control });
    const srtEnabled = useWatch({ name: 'srtEnabled', control });

    const inputs = allInputs.filter(({ type }) => type === inputType);

    const currentInput = allInputs.find((input) => input.id === inputId);
    const currentInputSrtSettings = currentInput?.srtSettings?.[0];

    if (inputType === MediaLiveInputType.LINK) {
        return <MediaLiveInputsSelect inputs={inputs} />;
    }

    if (inputType === MediaLiveInputType.PUSH || inputType === MediaLiveInputType.PULL) {
        return (
            <>
                {inputs.length > 0 && <MediaLiveInputsSelect inputs={inputs} />}
                {inputType === MediaLiveInputType.PUSH && !currentInput && (
                    <Checkbox {...register('srtEnabled', { shouldUnregister: true })} label="Use SRT protocol" />
                )}
                <MediaLiveNetworkUrl inputUrl={currentInput?.urls[0]} backupInputUrl={currentInput?.urls[1]} />
                {(currentInputSrtSettings || srtEnabled || pullSource?.startsWith('srt')) && (
                    <MediaLiveSrtSettings
                        srtSettings={currentInputSrtSettings}
                        inputType={inputType}
                        pullSource={pullSource}
                    />
                )}
            </>
        );
    }

    return <MediaLivePushInfo />;
}
